import React from 'react';

function ChatInput({ value, onChange, onSend, sending }) {
  function handleKey(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  }

  return (
    <div className="input-area">
      <textarea
        className="input-area__textarea"
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={handleKey}
        placeholder="Escribe una nota, decisión, tarea o riesgo..."
        rows={3}
        disabled={sending}
      />
      <button
        className="input-area__send"
        onClick={onSend}
        disabled={sending || !value.trim()}
        aria-label="Enviar"
      >
        {sending ? <span className="spin">⟳</span> : '↑'}
      </button>
    </div>
  );
}

export default ChatInput;
